// extracted by mini-css-extract-plugin
export default {"mic":"Mic_mic__ewej2","mic_img":"Mic_mic_img__RFGCo","bnw":"Mic_bnw__8iEsv","clicked":"Mic_clicked__WyhhT","mic_text":"Mic_mic_text__kN7fS"};